import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import Spinner from "../components/loader/Spinner";
import { Dialog } from "primereact/dialog";
import { MensajeAdvertencia } from "../components/mensajes/Mensajes";
import { Service } from "../service/Service";

import Environment from "../Environment";
import { RESET_PASSWORD } from "../genericos/Uris";
import ErrorSistema from "../components/error/ErrorSistema";
const getRoute = Environment();

const RessetPassword = () => {
    //-----------------| Objeto de servicio |-----------------
    const resetPasswordService = new Service();

    //-----------------| Lista de variables |-----------------
    const [cargar, setCargar] = useState(true);
    const [username, setUsername] = useState("");
    const [dialogo, setDialogo] = useState(false);
    const [mensajeAdv, setMensajeAdv] = useState("");
    //--> variables para el back
    const [mensajeBack, setMensajeBack] = useState("");
    const [estatus, setEstatus] = useState(false);
    const [errorSistema, setErrorSistema] = useState(false);

    let history = useHistory();

    useEffect(() => {
        setTimeout(() => {
            setCargar(false);
        }, 1000);
    }, []);

    const enviarUsuario = async () => {
        //--> Validar antes de envio back-end
        if (!username) {
            setMensajeAdv("Campo obligatorio");
            setTimeout(() => {
                setMensajeAdv("");
            }, 3000);
            return;
        }
        //--> Envio al back-end
        resetPasswordService.baseUrl = `${getRoute}/${RESET_PASSWORD}`;
        try {
            setCargar(true);
            const respuesta = await resetPasswordService.setPassword({
                username: username,
            });
            //--> Respuesta exitosa
            console.log(respuesta.response);
            setDialogo(true);
            setEstatus(true);
            setMensajeBack(
                "Por favor ingrese al link que se envio a su cuenta de correo para recuperar su contraseña."
            );
        } catch (error) {
            //--> Respuesta de error
            if (error.response === undefined) {
                setErrorSistema(true);
            } else {
                if (error.response.status === 400) {
                    setMensajeBack(error.response.data);
                    setDialogo(true);
                    setEstatus(false);
                }
            }
        } finally {
            setCargar(false);
        }
    };

    const envioExitoso = () => {
        setDialogo(false);
        history.push("/");
    };

    const botonDialogo = (
        <>
            <Button
                label="Aceptar"
                icon="pi pi-check"
                onClick={
                    estatus
                        ? envioExitoso
                        : () => {
                            setDialogo(false);
                        }
                }
            />
        </>
    );

    return (
        <>
            {cargar && <Spinner />}
            {!cargar && !errorSistema && (
                <div className="flex justify-content-center">
                    <div className="card">
                        <h5 className="text-center">Cambiar contraseña</h5>
                        <p className="text-center">Por favor ingresa tu nombre de usuario para recuperar tu contraseña.</p>
                        <div>
                            <div className="flex justify-content-center flex-wrap">
                                <div className="grid p-fluid">
                                    <div className="col-12 md:col-10">
                                        <InputText
                                            className={`text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary min-w-min md:w-20rem ${mensajeAdv && "p-invalid"
                                                }`}
                                            value={username}
                                            placeholder="Ingresa tu nombre de usuario"
                                            onChange={(e) => setUsername(e.target.value)} maxLength={10}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="mx-auto w-7">
                                {mensajeAdv && (
                                    <MensajeAdvertencia>{mensajeAdv}</MensajeAdvertencia>
                                )}
                            </div>
                            <div className="flex justify-content-center flex-wrap mt-3">
                                <Button
                                    className="w-3"
                                    icon="pi pi-check"
                                    label="Enviar"
                                    type="submit"
                                    onClick={enviarUsuario}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {errorSistema && <ErrorSistema />}
            <Dialog
                header="¡Atención!"
                visible={dialogo}
                style={{ width: "50vw" }}
                onHide={() => setDialogo(false)}
                footer={botonDialogo}
            >
                {mensajeBack}
            </Dialog>
        </>
    );
};

export default RessetPassword;
